import { en, TranslationKeys } from "./en";
import { da } from "./da";
import { de } from "./de";
import { es } from "./es";

export type Language = "en" | "da" | "de" | "es";

export const translations: Record<Language, TranslationKeys> = {
  en,
  da,
  de,
  es,
};

export const languageNames: Record<Language, { flag: string; name: string }> = {
  en: { flag: "🇺🇸", name: "English" },
  da: { flag: "🇩🇰", name: "Dansk" },
  de: { flag: "🇩🇪", name: "Deutsch" },
  es: { flag: "🇪🇸", name: "Español" },
};

export type { TranslationKeys };
